import { createContext, useContext, ReactNode, useMemo } from 'react'
import { useSavedState } from '../../hooks/useSavedState'
import { ScheduleCreateEventFilters, defaultScheduleCreateEventFilters } from './CreateEvent/scheduleCreateEventModel'
import { withoutUnavailableProjectTypes } from '../../common/constants'
import useServiceTicketsEnabled from '../../hooks/useServiceTicketsEnabled'

type ScheduleFiltersContextType = {
  createEventFilters: ScheduleCreateEventFilters
  setCreateEventFilters: (filters: ScheduleCreateEventFilters) => void
}

const ScheduleFiltersContext = createContext<ScheduleFiltersContextType | undefined>(undefined)

export const ScheduleFiltersProvider = ({ children }: { children: ReactNode }) => {
  const [createEventFilters, setCreateEventFilters] = useSavedState('schedule_create_event_filters', defaultScheduleCreateEventFilters)
  const showServiceTickets = useServiceTicketsEnabled()
  const availableFilters = useMemo(() => ({
    ...createEventFilters,
    projectTypeIds: withoutUnavailableProjectTypes(createEventFilters.projectTypeIds, showServiceTickets),
  }), [createEventFilters, showServiceTickets])
  const value = useMemo(() => ({ createEventFilters: availableFilters, setCreateEventFilters }), [availableFilters, setCreateEventFilters])
  return (
    <ScheduleFiltersContext.Provider value={value}>
      {children}
    </ScheduleFiltersContext.Provider>
  )
}

export const useScheduleFilters = () => {
  const context = useContext(ScheduleFiltersContext)
  if (context === undefined) {
    throw new Error('useScheduleFilters must be used within a ScheduleFiltersProvider')
  }
  return context
}
